import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import ThankYou from "./pages/ThankYou";
const App = () => {
  return (
    <>
      <BrowserRouter>
        <div id="top" className="dino-startup">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/thankyou" element={<ThankYou />} />
          </Routes>
        </div>
      </BrowserRouter>
    </>
  );
};

export default App;
